var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import './InputWithClick.scss';
var InputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n"], ["\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n"])));
var StyledInput = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  padding: 8px;\n  pointer-events: none; /* \u041E\u0442\u043A\u043B\u044E\u0447\u0430\u0435\u043C \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 */\n"], ["\n  width: 100%;\n  padding: 8px;\n  pointer-events: none; /* \u041E\u0442\u043A\u043B\u044E\u0447\u0430\u0435\u043C \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 */\n"])));
var ClickableOverlay = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: pointer;\n"])));
function InputWithClick(_a) {
    var error = _a.error, register = _a.register, placeholder = _a.placeholder, onInputClick = _a.onInputClick;
    return (_jsxs(InputContainer, { children: [_jsx(StyledInput, __assign({}, register, error, { className: "InputWithClick ".concat(error ? 'error' : ''), placeholder: placeholder, disabled: true })), _jsx(ClickableOverlay, { onClick: onInputClick })] }));
}
export default InputWithClick;
var templateObject_1, templateObject_2, templateObject_3;
